import { put, takeLatest, call, takeEvery, fork, select } from "redux-saga/effects";
import * as API from "../../../containers/APIurls";
import apiClient from "../../../utils/apiClient";
import * as LowerFunnelSlice from "./LowerFunnelSlice";
import LowerFunnelSections from './LowerFunnelSections.json'
import { initializeCheckout } from "pages/Checkout/ducks/sagas";

function* getCheckoutSectionsInfo(params) {
  try {
    const isPlans = localStorage.getItem("planspage") ?? false
    const globalData = yield select(state => state.ProspectWidgets_GlobalData)
    const clientName = globalData?.widgetInputParams?.clientName?.value
    const sessionCartData = globalData?.sessionCartData?.apiResponse?.prospectFlowData;
    const bussProducts = (sessionCartData?.cart?.packages !== null && sessionCartData?.cart?.packages !== undefined) ? Object.values(sessionCartData?.cart?.packages).filter(data => (data.buss && data.tncUrl) ? true : false) : undefined;
    const bussProductsHardware = (sessionCartData?.cart?.packages !== null && sessionCartData?.cart?.packages !== undefined) ? Object.values(sessionCartData?.cart?.packages).filter(data => (data.buss && data.tncUrl && String(data.productType).toLowerCase().includes('hardware')) ? true : false) : undefined;
    const onlyBuss = (sessionCartData?.cart?.packages !== null && sessionCartData?.cart?.packages !== undefined) ? Object.values(sessionCartData?.cart?.packages).filter(data => (!data.buss) ? true : false) : undefined;
    yield put(LowerFunnelSlice.setCheckoutLoading(true));
    const response = yield apiClient.post(API.GET_LOWER_FUNNEL_SECTIONS);
    //  const response =  {status:200,data:{sections : LowerFunnelSections[isPlans ? "marketPlaceFWALoggedIn" : clientName == "MYBIZ" ? 'marketPlaceLoggedIn' : clientName == "prospect" ? 'bussSection' : 'defaultSections']}}
    //change condition here once have api working
    yield call(initializeCheckout, {});
    const lowerFunnelSec = yield select(state => state.LowerFunnelSlice.sectionsConfig)
    const shoppingCartPageRevisited = yield select(state => state.LowerFunnelSlice.shoppingCartPageRevisited)
    const isRevisit = shoppingCartPageRevisited;
    if (response?.status == 200) {
      yield put(LowerFunnelSlice.setShoppingCartPageRevisitedLower(true))
      yield put(LowerFunnelSlice.setShoppingCartPageRevisited(true));
      let resultData = response.data;
      let updatedSections = { ...resultData };
      if (lowerFunnelSec !== null && lowerFunnelSec && Object.keys(lowerFunnelSec).length) {
        Object.entries(lowerFunnelSec).map(([key, value]) => {
          if (!isRevisit) {
            if (!!resultData['sections'] && resultData['sections'][key] !== null && resultData['sections'][key] && Object.keys(resultData['sections'][key]).length) {
              resultData['sections'][key] = { ...value }
            }
          }
          else if (isRevisit && key === 'MbtBusinessContracts' && !!resultData && resultData.sections[key] && Object.keys(resultData.sections[key]).length) {
            let businessValue = {
              // ...value,
              isActive: true,
              isComplete: false,
              order: 200,
              ["subsections"]: {
                // ...value['subsections'],
                ['terms-n-conditions']:
                {
                  // ...value['subsections']['terms-n-conditions'],
                  isActive: true,
                  isComplete: false,
                  order: 2.0
                }
              }
            }
            // let billingSection = {...value,isActive:true,isComplete:false,["subsections"]:{...value['subsections'],['terms-n-conditions']:{...value['subsections']['terms-n-conditions'],isActive:true,isComplete:false}}}
            // resultData = {...resultData,[key]:{...businessValue}}   
            updatedSections.sections[key] = {
              ...(updatedSections[key] || resultData.sections[key] || {}),
              ...businessValue,
            }
          }
          else if (isRevisit && key === 'BusinessInformation' && !!resultData && resultData.sections[key] && Object.keys(resultData.sections[key]).length) {
            let billSecValue = {
              isActive: false,
              isComplete: true,
              order: 100,
              ["subsections"]: {
                ['billing-information']: {

                  isActive: false, isComplete: true,
                  order: 1.0,
                }
              }
            }
            updatedSections.sections[key] = {
              ...(updatedSections[key] || resultData.sections[key] || {}),
              ...billSecValue,
            }
          }
        })

        resultData.sections = {
          ...resultData.sections,
          ...updatedSections.sections,
        };
      }
      if (bussProducts && bussProducts.length) {
        Object.entries(resultData['sections']).map(([key, value]) => {
          const dontIncludeTnC = (onlyBuss && onlyBuss.length) ? true : false
          if (String(key).toLowerCase().includes('businesscontracts') && dontIncludeTnC) {
            resultData['sections'] = {
              ...resultData['sections'], [key]: {
                ...value, ['subsections']: {
                  ...value['subsections'], "terms-n-conditions-buss": {
                    "title": "Third party terms and conditions",
                    "isActive": false,
                    "isComplete": value['isComplete'],
                    "isEditable": false,
                    "order": 30.0
                  }
                }
              }
            }
          }
          if (bussProductsHardware && bussProductsHardware.length && key === "ShippingAndPayment") {
            resultData['sections'] = {
              ...resultData['sections'], [key]: {
                ...value, ['subsections']: {
                  ...value['subsections'], "shipping-hardware": {
                    "title": "Third Party Shipping Details",
                    "isActive": false,
                    "isComplete": false,
                    "isEditable": true,
                    "order": 15
                  }
                }
              }
            }
          }
        })
      }
      if (isRevisit) {
        // yield put(LowerFunnelSlice.setCurrentOrder({}))
        //yield put(setCreditDetailsResponse({})) 
      }
      yield put(LowerFunnelSlice.setCheckoutSections(resultData));
      yield put(LowerFunnelSlice.setCheckoutLoading(false));
    } else {
      //   yield put(ReviewSlice.setAccountSecurityQueRes({ status: false }));

    }
  } catch (err) {
    yield put(LowerFunnelSlice.setCheckoutLoading(true));
  }
}


function* getStoreInfo(action) {
  try {
    const zipCode = action.payload;
    if (zipCode.length === 5) {
      const request = {
        zipCode: zipCode,
        storeType: 'direct',
        shoppingPath: 'PROSPECT',
        approach: '',
        flow: 'prospect',
      };

      const response = yield call(apiClient.post, API.STORE_INFORMATION_URL, request);

      if (response?.status === 200) {
        const resultData = response.data;
        yield put(LowerFunnelSlice.setStoreInfo(resultData));
        yield put(LowerFunnelSlice.setCheckoutLoading(false));
      } else {
        yield put(LowerFunnelSlice.setCheckoutLoading(true));
      }
    }
  } catch (err) {
    yield put(LowerFunnelSlice.setCheckoutLoading(true));
  }
}

function* getStoreInfoForISPU(params) {
  const globalData = yield select(state => state.ProspectWidgets_GlobalData)
  const widgetInputParams = globalData?.widgetInputParams;
  try {
    yield put(LowerFunnelSlice.setIspuLoading(true));
    const { zipCode, quantity, selectedSku } = params.payload;
    if (zipCode.length === 5) {
      const request = {
        zipCode: zipCode,
        storeType: 'direct',
        shoppingPath: 'PROSPECT',
        approach: '',
        flow: 'prospect',
      };
      const requestBody = {
        "ecpdId": window?.mbtGlobal?.ecpdId,
        "userId": widgetInputParams?.mbLoginId?.value ??
          window?.mbtGlobal?.userId ??
          widgetInputParams?.loginUserId?.value ??
          widgetInputParams?.mbaUserId?.value ??
          window?.mbtGlobal?.userId,
        "zip": zipCode,
        "radius": "50",
        "skuList": [
          {
            "quantity": quantity,
            "sku": selectedSku?.sku
          }
        ]
      }
      const response = yield call(apiClient.post, API.PDP_STORE_INFORMATION_URL, requestBody);

      if (response?.status === 200) {
        const resultData = response.data;
        yield put(LowerFunnelSlice.setStoreInfo(resultData));
       yield put(LowerFunnelSlice.setIspuLoading(false));
      }
    }
  } catch (err) {
    yield put(LowerFunnelSlice.setIspuLoading(false));
  }
  finally{
    yield put(LowerFunnelSlice.setIspuLoading(false));
  }
}
export default function* actionWatcher() {
  yield takeLatest(LowerFunnelSlice.getCheckoutSections.type, getCheckoutSectionsInfo);
  yield takeLatest(LowerFunnelSlice.getStoreInfo.type, getStoreInfo);
  yield takeLatest(LowerFunnelSlice.getStoreInfoForISPU.type, getStoreInfoForISPU);
}
